import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Presenter } from '../../helpers/presenter.helper';
import { ICalculator } from '../../interfaces/calculator.interface';

@Injectable()
export class CalculatorPresenter extends Presenter<ICalculator> {
    /**
     * Type  of calculator presenter
     */
    type: FormControl;
    /**
     * Business name of profile tab company data presenter
     */
    send!: FormControl;
    /**
     * Email  of profile tabs contact presenter
     */
    receive!: FormControl;
    /**
     * Currency name of calculator presenter
     */
    currencyName!: FormControl;
    /**
     * Exchange currency name of calculator presenter
     */
    exchangeCurrencyName!: FormControl;
    /**
     * Currency credit card name of calculator presenter
     */
    currencyCreditCardName!: FormControl;
    /**
     * Exchange currency credit card name of calculator presenter
     */
    exchangeCurrencyCreditCardName!: FormControl;
    /**
     * Commission symbol of calculator presenter
     */
    commissionSymbol!: FormControl;
    /**
     * Card bank commission of calculator presenter
     */
    cardBankCommission!: FormControl;
    /**
     * Operation bank commission of calculator presenter
     */
    operationBankCommission!: FormControl;
    /**
     * Amount due card of calculator presenter
     */
    amountDueCard!: FormControl;
    /**
     * Determines whether credi card has
     */
    hasCrediCard!: FormControl;
    /**
     * Service type of calculator presenter
     */
    serviceType!: FormControl;
    /**
     * Code of calculator presenter
     */
    code: FormControl;
    /**
     * Creates an instance of profile tab company data presenter.
     * @param fb FormBuilder
     */
    constructor(private fb: FormBuilder) {
        super();
        this.initializeInputs();
        this.createform();
    }
    /**
     * Initializes inputs
     */
    private initializeInputs() {
        this.type = new FormControl(null, null);
        this.currencyName = new FormControl(null, null);
        this.exchangeCurrencyName = new FormControl(null, null);
        this.send = new FormControl(null, [Validators.required]);
        this.receive = new FormControl(null, [Validators.required]);
        this.currencyCreditCardName = new FormControl(null, null);
        this.exchangeCurrencyCreditCardName = new FormControl(null, null);
        this.commissionSymbol = new FormControl(null, null);
        this.cardBankCommission = new FormControl(0, null);
        this.operationBankCommission = new FormControl(0, null);
        this.amountDueCard = new FormControl(100, null);
        this.hasCrediCard = new FormControl(false, null);
        this.serviceType = new FormControl(null, null);
        this.code = new FormControl(null,null);
    }
    /**
     * Createforms profile tab company data presenter
     */
    private createform() {
        this.form = this.fb.group({
            currencyName: this.currencyName,
            exchangeCurrencyName: this.exchangeCurrencyName,
            type: this.type,
            send: this.send,
            receive: this.receive,
            currencyCreditCardName: this.currencyCreditCardName,
            exchangeCurrencyCreditCardName: this.exchangeCurrencyCreditCardName,
            commissionSymbol: this.commissionSymbol,
            cardBankCommission: this.cardBankCommission,
            operationBankCommission: this.operationBankCommission,
            amountDueCard: this.amountDueCard,
            hasCrediCard: this.hasCrediCard,
            serviceType: this.serviceType,
            code: this.code,
        });
    }
}
